export default "__VITE_ASSET__SyHayEgO__"